import * as apiSW from 'api/ingredient/GetIngredientStartingWithV1';
import { SearchLogic } from 'enums/searchLogic';

export type Type = {
	id: string;
	name: string;
	logic: SearchLogic;
};

export function create(): Type {
	return {
		id: '',
		name: '',
		logic: SearchLogic.Include,
	};
}

export function mapFromApi(input: apiSW.ResponseIngredient): Type {
	return {
		id: input.id,
		name: input.description ?? '',
		logic: SearchLogic.Include,
	};
}
